import { render, staticRenderFns } from "./prescriptionTable.vue?vue&type=template&id=f2b4c4e2&scoped=true"
import script from "./prescriptionTable.vue?vue&type=script&lang=js"
export * from "./prescriptionTable.vue?vue&type=script&lang=js"
import style0 from "./prescriptionTable.vue?vue&type=style&index=0&id=f2b4c4e2&prod&lang=scss"
import style1 from "./prescriptionTable.vue?vue&type=style&index=1&id=f2b4c4e2&prod&lang=scss&scoped=true"
import style2 from "./prescriptionTable.vue?vue&type=style&index=2&id=f2b4c4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4c4e2",
  null
  
)

export default component.exports